import { IDocumentState, IDocumentStateFulfilled, IStateRejected } from '../../interfaces';
import { documentAction } from '../actions';

const getDocument = () => {
  const { pending, fulfilled, rejected } = documentAction.getDocument;
  return {
    // Pending
    [pending.type]: (state: IDocumentState): IDocumentState => ({
      ...state,
      status: 'loading',
      error: '',
    }),
    // Fulfilled
    [fulfilled.type]: (state: IDocumentState, action: IDocumentStateFulfilled): IDocumentState => ({
      status: 'success',
      categories: action.payload.map((category) => ({
        _id: category._id,
        order: category.order,
        active: category.active,
        createdAt: category.createdAt,
        description: category.description,
        name: category.name,
        componentProps: category.componentProps,
        showFrontProps: category.showFrontProps,
        options: category.options,
      })),
      error: '',
    }),
    // Rejected
    [rejected.type]: (state: IDocumentState, action: IStateRejected): IDocumentState => ({
      categories: null,
      status: 'error',
      error: action.error.message,
    }),
  };
};

export default {
  ...getDocument(),
};
